import { AccountDatasource } from '../datasources/account_datasource';
import { ICommand } from '../../../vendor/core-ts-types/dist/main';

export class UserAppRouteConfiguration {
  constructor(private $stateProvider: ng.ui.IStateProvider) {}

  state() {
    this.$stateProvider
      .state('confirm', {
        url: '/confirm/:confirmationCode/',
        controller: 'ngConfirmAccountController'
      })
      .state('my', {
        url: '/my/',
        abstract: true,
        templateUrl: 'lib/user_app/views/my/my.html',
        controller: 'ngMyController',
        controllerAs: '$ctrl',
        resolve: {
          _config: (loadConfigCommand: ICommand) => {
            return loadConfigCommand();
          },
          _displayMessages: (loadDisplayMessagesCommand: ICommand) => {
            return loadDisplayMessagesCommand();
          },
          _accessToken: function(
            restoreLocalAccountCommand: ICommand,
            requestAnonymousAccountCommand: ICommand,
            $state: ng.ui.IStateService
          ): ng.IPromise<void> {
            return restoreLocalAccountCommand()
              .then((accountDatasource: AccountDatasource) => {
                const {
                  is_transfer_counselor,
                  is_transfer_admin,
                  is_transfer_analytics_user,
                  is_application_admin
                } = accountDatasource.read();
                const is_admin_user =
                  is_transfer_admin || is_transfer_counselor || is_transfer_analytics_user || is_application_admin;
                if (is_admin_user) {
                  $state.transitionTo('admin', {}, { reload: true });
                }
              })
              .catch(() => {
                return requestAnonymousAccountCommand();
              })
              .catch(() => {
                $state.go('landing', {
                  explanation: 'You do not have a valid session open'
                });
              });
          },
          _loadSession: function(loadSessionCommand: ICommand, _accessToken: ng.IPromise<never>): ng.IPromise<any> {
            return loadSessionCommand();
          },
          _transferStudent: function(loadTransferStudentCommand: ICommand, _accessToken: ng.IPromise<never>) {
            return loadTransferStudentCommand();
          }
        }
      })
      .state('my.account', {
        url: 'account/',
        sticky: true,
        views: {
          'my@my': {
            templateUrl: 'lib/user_app/views/account/account.html'
          },
          'left@my.account': {
            templateUrl: 'lib/user_app/views/login/login.html',
            controller: 'ngLoginController',
            controllerAs: '$ctrl'
          },
          'right@my.account': {
            templateUrl: 'lib/user_app/views/create_profile/create_profile.html',
            controller: 'ngCreateProfileController',
            controllerAs: '$ctrl'
          }
        },
        data: {
          viewTitle: 'Account Login'
        }
      } as any)
      .state('my.profile', {
        url: 'profile/',
        sticky: true,
        abstract: true,
        views: {
          'my@my': {
            templateUrl: 'lib/user_app/views/profile/profile.html'
          },
          'left@my.profile': {
            templateUrl: 'lib/user_app/views/profile_menu/profile_menu.html',
            controller: 'ngProfileMenuController',
            controllerAs: '$ctrl'
          }
        },
        onEnter: (ngAccountDatasource: AccountDatasource, $state: ng.ui.IStateService) => {
          if (ngAccountDatasource.isAnonymous()) {
            $state.go('my.account');
          }
        }
      } as any)
      .state('my.profile.account_settings', {
        url: 'account-settings/',
        sticky: true,
        views: {
          'right@my.profile': {
            templateUrl: 'lib/user_app/views/update_profile/update_profile.html',
            controller: 'ngUpdateProfileController',
            controllerAs: '$ctrl'
          }
        },
        data: {
          viewTitle: 'Account Settings'
        }
      } as any)
      .state('my.profile.additional_information', {
        url: 'additional-information/?source',
        sticky: true,
        views: {
          'right@my.profile': {
            templateUrl: 'lib/user_app/views/additional_information/additional_information.html',
            controller: 'ngAdditionalInformationController',
            controllerAs: '$ctrl'
          }
        },
        resolve: {
          // FIXME these get called every time we go to this state
          _loadStudentTypes: (loadStudentTypesCommand: ICommand, _accessToken: ng.IPromise<never>) =>
            loadStudentTypesCommand(),
          _loadTerms: (loadStudentTermsCommand: ICommand, _accessToken: ng.IPromise<never>) =>
            loadStudentTermsCommand(),
          _loadProfile: (loadStudentProfileCommand: ICommand, _accessToken: ng.IPromise<never>) =>
            loadStudentProfileCommand()
        },
        data: {
          viewTitle: 'Additional Information'
        }
      } as any)
      .state('my.reset_password', {
        abstract: true,
        sticky: true,
        url: 'reset-password/',
        views: {
          'my@my': {
            template: '<ui-view></ui-view>'
          }
        }
      } as any)
      .state('my.reset_password.enter_email', {
        url: 'enter-email/',
        templateUrl: 'lib/user_app/views/enter_email/enter_email.html',
        controller: 'ngEnterEmailController',
        controllerAs: '$ctrl',
        data: {
          viewTitle: 'Reset Your Password'
        }
      })
      .state('my.reset_password.set_new', {
        url: 'set-new/:resetPasswordCode/',
        templateUrl: 'lib/user_app/views/reset_password/reset_password.html',
        controller: 'ngResetPasswordController',
        controllerAs: '$ctrl',
        data: {
          viewTitle: 'Account Reset Password'
        },
        resolve: {
          _validateKey: function(
            validateResetPasswordKeyCommand: ICommand,
            $state: ng.ui.IStateService,
            $stateParams: ng.ui.IStateProvider
          ): ng.IPromise<void> {
            return validateResetPasswordKeyCommand($stateParams['resetPasswordCode']).catch(() => {
              $state.go(`my.reset_password.enter_email`);
            });
          }
        }
      })
      .state('my.email_sent', {
        url: 'email-sent/',
        views: {
          'my@my': {
            templateUrl: 'lib/user_app/views/email_sent/email_sent.html',
            controller: 'ngEmailSentController',
            controllerAs: '$ctrl'
          }
        },
        params: {
          subject: '',
          email: ''
        },
        data: {
          viewTitle: 'Account Email Sent'
        }
      })
      .state('my.modal', {
        url: 'modal/',
        abstract: true
      })
      .state('my.modal.timeout', {
        url: 'timeout/',
        views: {
          'modal@my': {
            templateUrl: 'lib/global/prompts/session_warning/session_warning.html',
            controller: 'ngSessionWarningController',
            controllerAs: '$ctrl'
          }
        },
        data: {
          viewTitle: 'Session Timeout'
        }
      });
  }

  $get() {
    return {};
  }
}

angular.module('capability-ng-user-app').provider('ngUserAppRouteConfiguration', UserAppRouteConfiguration);



// WEBPACK FOOTER //
// ./app/lib/user_app/configuration/route_configuration.ts